import axios from "axios";

const prepareData = (data) => {return {project_twr_esm_category:data}}

// Plural Actions
export const GET_PROJECT_TWR_ESM_CATEGORIES = "get_project_twr_esm_categories";
export const getProjectTwrEsmCategories = () => {
	const url = `/project/twr/esm_categories.json`
	const request = axios.get(url);
	return {
		type: GET_PROJECT_TWR_ESM_CATEGORIES,
		payload: request
	};
};


// Singular Actions
export const CREATE_PROJECT_TWR_ESM_CATEGORY = "create_project_twr_esm_category";
export const createProjectTwrEsmCategory = (data) => {
	const url = `/project/twr/esm_categories.json`
	const request = axios({method: "post",url: url,data: prepareData(data)});
	return {
		type: CREATE_PROJECT_TWR_ESM_CATEGORY,
		payload: request
	};
};

export const GET_PROJECT_TWR_ESM_CATEGORY = "get_project_twr_esm_category";
export const getProjectTwrEsmCategory = (id) => {
	const url = `/project/twr/esm_categories/${id}.json`
	const request = axios.get(url);
	return {
		type: GET_PROJECT_TWR_ESM_CATEGORY,
		payload: request
	};
};

export const UPDATE_PROJECT_TWR_ESM_CATEGORY = "update_project_twr_esm_category";
export const updateProjectTwrEsmCategory = (id,data) => {
	const url = `/project/twr/esm_categories/${id}.json`
	const request = axios({method: "patch",url: url,data: prepareData(data)});
	return {
		type: UPDATE_PROJECT_TWR_ESM_CATEGORY,
		payload: request
	};
};

export const DESTROY_PROJECT_TWR_ESM_CATEGORY = "destroy_project_twr_esm_category";
export const destroyProjectTwrEsmCategory = (id) => {
	const url = `/project/twr/esm_categories/${id}.json`
	const request = axios({method: "delete",url: url});
	return {
		type: DESTROY_PROJECT_TWR_ESM_CATEGORY,
		payload: request
	};
};
